import { Component, Input, OnInit } from '@angular/core';
import { InvoiceInterface, InvoiceStatus } from '@contracts/interfaces/invoice.interface';
import { InvoiceComponent } from '../invoice';


@Component({
  selector: 'app-invoice-repair',
  templateUrl: './invoice-repair.component.html',
  styleUrls: ['./invoice-repair.component.scss', '../../pages/invoice-table.scss']
})
export class InvoiceRepairComponent extends InvoiceComponent implements OnInit {
  @Input()
  invoice: InvoiceInterface;

  defaultInvoice = {
    type: "repair",
    status: InvoiceStatus.Unpaid,
    customer: null,
    number: null,
    custom: "",
    dateCreated: new Date(),
    dateDue: new Date(),
    subTotal: 0,
    total: 0,
    paymentsMade: [],
    pdf: {
      file: "invoice-repair-lab"
    },
    lineItems: [
      {
        item: '',
        desc: '',
        qty: 1,
        price: 0
      }
    ],
    gst: 0,
    isGSTIncluded: true,
    communicationLog: []
  }
}
